import type { Condition } from "./question";

export type Answer = {
  id: string;
  translationKey: string;
  descriptionTranslationKey?: string;
  conditionalOn?: Condition[];
  exclusive?: boolean; // If true, selecting this answer will deselect all other answers in the same question
};

/**
 * Union type for all possible answer values:
 * - string: TEXT, DROPDOWN
 * - string[]: MULTIPLE_CHOICE
 * - Record<string, string>: TEXT_GROUP
 */
export type AnswerValue = string | string[] | Record<string, string>;

export type AssessmentAnswer = {
  questionId: string;
  answerId: AnswerValue;
};

/**
 * Returns true if the answer represents an empty/cleared value.
 * Handles all AnswerValue shapes plus null/undefined for safety.
 */
export const isEmptyAnswer = (
  answer: AnswerValue | null | undefined,
): boolean => {
  if (answer == null) {
    return true;
  }

  if (typeof answer === "string") {
    return answer === "";
  }

  if (Array.isArray(answer)) {
    return answer.length === 0;
  }

  return Object.values(answer).every((value) => value === "");
};
